import styled from '@emotion/styled';
import { CheckSingleIcon } from 'src/domains/layouts/shared/assets/icons/CheckSingleIcon';
import { withConfig } from 'src/withConfig';

export const SuccessOverlayWrapper = withConfig(theme => styled('div', { label: 'SuccessOverlayWrapper' })`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${theme.star.idMission.bgColorTertiary};
    z-index: ${theme.star.zIndexIdMission.idMission};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 24px;
`);

export const SuccessOverlayLogo = styled('div', { label: 'SuccessOverlayLogo' })`
    width: 200px;
    display: flex;
    justify-content: center;
    margin-bottom: 32px;

    svg {
        width: 100%;
        height: 100%;
    }
`;

export const SuccessOverlayIcon = withConfig(theme => styled(CheckSingleIcon, { label: 'SuccessOverlayIcon' })`
    background: ${theme.star.idMission.bgColorQuaternary};
    border-radius: 50%;
    display: block;
    height: 46px;
    width: 46px;
    padding: 12px;
    margin-bottom: 32px;
    fill: white;
`);

export const SuccessOverlayText = styled('div', { label: 'SuccessOverlayText' })`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    text-align: center;
`;

export const SuccessOverlayParagraph = withConfig(theme => styled('div', { label: 'SuccessOverlayParagraph' })`
    width: 316px;
    margin: 0;
    font-size: ${theme.star.fontSize.regular};
    font-weight: ${theme.star.fontWeight.medium};
    color: ${theme.star.idMission.bgColorSecondary};
`);

export const SuccessOverlayButtonWrapper = styled('div', { label: 'SuccessOverlayButtonWrapper' })`
    width: 240px;
    margin-top: 60px;

    button {
        width: 100%;
    }
`;
